import React, { useEffect, useState } from 'react';
import {
    Box,
    Grid,
    TextField,
    Button,
    Typography
} from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { Formik } from 'formik';
import { create, get } from '../../../API/API';
import { makeStyles } from '@mui/styles';
import { useSnackbar } from 'notistack';
import Page from '../../../components/layouts/Page';
import Title from '../../../components/layouts/Title';
import Thumb from '../../../components/elements/Thumb';
import RichText from '../RichText';

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.dark,
        minHeight: '100%',
    },
    container: {
        padding: 47,
    },
    '@global': {
        html: {
            width: '100%',
            height: '100%',
        },
    },
    formControl: {
        marginTop: 16,
        marginBottom: 15,
    },
    title: {
        padding: 20
    },
    wrap: {
        padding: 40,
        borderRadius: 5,
        boxShadow:
            '-1px 2px 4px -1px rgb(0 0 0 / 3%), 0px 4px 5px 0px rgb(0 0 0 / 3%), 0px 1px 10px 0px rgb(0 0 0 / 4%)',
    },
}));

const AddRuta = (props) => {
    const classes = useStyles();
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();
    const { id } = useParams();
    const { tipus } = useParams();
    const [text, setText] = useState(null);

    const crearEntorn = async (values) => {
        const data = {
            titol: values.titol,
            text: text,
            imatge: values.imatge,
            distancia: values.distancia,
            desnivell: values.desnivell,
            dificultat: values.dificultat,
            tipus: tipus,
            link: values.link,
            masia_id: id
        }
        const result = await create('crearRuta', data);
        enqueueSnackbar(result.message, {
            variant: 'success',
        });
        props.setActualitzar(true);
        navigate(-1, { state: values });
    };

    return (
        <Page title="Add Ruta">
            <Formik
                initialValues={{
                    titol: ''
                }}
                // validationSchema={Yup.object().shape({
                //     name: Yup.string().required('El nom és obligatòri')
                // })}
                onSubmit={(values) => {
                    crearEntorn(values);
                }}
            >
                {({
                    errors,
                    handleBlur,
                    handleChange,
                    handleSubmit,
                    touched,
                    values,
                    setFieldValue,
                }) => (
                    <form onSubmit={handleSubmit}>
                        <div style={{padding: '0 40px'}}>
                            <Title
                                title={'Afegir Ruta'}
                                subtitle={
                                    'Entra les dades per guardar una nova entrada'
                                }
                            />
                        </div>
                        <Box className={classes.wrap}>
                            <Grid container spacing={3}>
                                <Grid item md={6}>
                                    <TextField
                                        error={Boolean(
                                            touched.titol && errors.titol
                                        )}
                                        fullWidth
                                        helperText={
                                            touched.titol && errors.titol
                                        }
                                        label="Titol"
                                        margin="normal"
                                        name="titol"
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        type="text"
                                        value={values.titol}
                                    />
                                </Grid>
                                <Grid item md={6}>
                                    <TextField
                                        error={Boolean(
                                            touched.link && errors.link
                                        )}
                                        fullWidth
                                        helperText={
                                            touched.link && errors.link
                                        }
                                        label="Enllaç"
                                        margin="normal"
                                        name="link"
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        type="link"
                                        value={values.link}
                                    />
                                </Grid>
                            </Grid>
                            <Grid container spacing={3}>
                                <Grid item md={4}>
                                    <TextField
                                        error={Boolean(
                                            touched.distancia && errors.distancia
                                        )}
                                        fullWidth
                                        helperText={
                                            touched.distancia && errors.distancia
                                        }
                                        label="Distància"
                                        margin="normal"
                                        name="distancia"
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        type="link"
                                        value={values.distancia}
                                    />
                                </Grid>
                                <Grid item md={4}>
                                    <TextField
                                        error={Boolean(
                                            touched.desnivell && errors.desnivell
                                        )}
                                        fullWidth
                                        helperText={
                                            touched.desnivell && errors.desnivell
                                        }
                                        label="Desnivell"
                                        margin="normal"
                                        name="desnivell"
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        type="desnivell"
                                        value={values.desnivell}
                                    />
                                </Grid>
                                <Grid item md={4}>
                                    <TextField
                                        error={Boolean(
                                            touched.dificultat && errors.dificultat
                                        )}
                                        fullWidth
                                        helperText={
                                            touched.dificultat && errors.dificultat
                                        }
                                        label="Dificultat"
                                        margin="normal"
                                        name="dificultat"
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        type="dificultat"
                                        value={values.dificultat}
                                    />
                                </Grid>
                            </Grid>
                            <Grid container spacing={3}>
                                <Grid item md={12}>
                                    <RichText f_setData={setText} initialValue={''}/>
                                </Grid>
                            </Grid>
                            <Grid container spacing={3}>
                                <Grid item md={6} xs={12}>
                                    <Box mt={2}>
                                        <Typography>Imatge</Typography>
                                        <input
                                            id="imatge"
                                            name="imatge"
                                            type="file"
                                            inputProps={{ accept: "image/png, image/jpeg"}}
                                            required={false}
                                            onChange={(event) => {
                                                setFieldValue(
                                                    'imatge',
                                                    event.currentTarget.files[0]
                                                );
                                            }}
                                        />
                                    </Box>
                                    <Box p={2}>
                                        <Thumb file={values.imatge} />
                                    </Box>
                                </Grid>
                            </Grid>

                            <Box my={2} sx={{maxWidth: '50%', paddingTop: '40px', margin: '0 auto'}}>
                                <Button
                                    color="primary"
                                    fullWidth
                                    size="large"
                                    type="submit"
                                    variant="contained"
                                >
                                    {'crear'}
                                </Button>
                            </Box>
                        </Box>
                    </form>
                )}
            </Formik>
        </Page>
    );
};

export default AddRuta;
